export class InformacaoBasicaDTO {
    constructor() {
        this.TipoOperacao = null;
        this.EntradaEstimada = new Date();
        this.SaidaEstimada = new Date();
        this.TaxaCambioReal = null;
        this.ValorCifDolar = null;
        this.QtdContainers = null;
        this.TamanhoContainer = null;
        this.ValorCifReal = null;
        this.CargaImo = false;
        this.CargaOOG = false;
        this.CargaReefer = false;
        this.CargaAnvisa = false;
        this.Tonelagem = null;
        this.Volume = null;
        this.Transporte = null;
    }
}
